import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { fetchPhotonApi } from '@/domain/position-geocode/utils/search-geocode/photon-api';
import { PhotonFeature } from '@/domain/position-geocode/utils/search-geocode/photon-api.dto';
import { mapPhotonFeatureToPosition } from '@/domain/position-geocode/utils/search-geocode/photon-api-mapper-to-position-geocode';

export async function getGeocodePositionFromText(
  text: string,
): Promise<PositionGeocode | undefined> {
  const positionFound = await findPositoniWithApiPhoton(text);
  return positionFound;
}

async function findPositoniWithApiPhoton(
  text: string,
): Promise<PositionGeocode | undefined> {
  if (!text) {
    return undefined;
  }
  const query = text;
  const limit = 1;
  const features: PhotonFeature[] = await fetchPhotonApi(query, limit);
  const positionFound = convertPhotonFeatureToPosition(features);
  return positionFound;
}

function convertPhotonFeatureToPosition(
  features: PhotonFeature[],
): PositionGeocode | undefined {
  if (features.length === 0) {
    return undefined;
  }
  const feature = features[0];
  const position = mapPhotonFeatureToPosition(feature);
  return position;
}
